

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { add, remove } from '../slices/loading/loadingSlice';
import { loginActions } from '../slices/login';
import { serviceActions } from '../slices/service';
import { regionActions } from '../slices/region';
import { provinceActions } from '../slices/province';
import { municipalityActions } from '../slices/municipality';
import { barangayActions } from '../slices/barangay';
import { transactionActions } from '../slices/transaction';
import { transactionTypeActions } from '../slices/transaction-type';
import { ownershipTypeActions } from '../slices/ownership-type';
import { serviceTypeActions } from '../slices/service-type';
import { routeActions } from '../slices/route';
import { transactionTypeRequirementActions } from '../slices/transaction-type-requirement';
import { applicationActions } from '../slices/application';
import { paymentActions } from '../slices/payment';
import { appointmentActions } from '../slices/appointment';
import { branchActions } from '../slices/branch';
import { get } from 'lodash';

const combinedActions = {
  auth: loginActions,
  service: serviceActions,
  region: regionActions,
  province: provinceActions,
  municipality: municipalityActions,
  barangay: barangayActions,
  transaction: transactionActions,
  transactionType: transactionTypeActions,
  ownershipType: ownershipTypeActions,
  serviceType: serviceTypeActions,
  route: routeActions,
  transactionTypeRequirement: transactionTypeRequirementActions,
  application: applicationActions,
  payment: paymentActions,
  appointment: appointmentActions,
  branch: branchActions
}

const useAction = (path, props) => {
  const dispatch = useDispatch();
  
  return useCallback(async (...args) => {

      await dispatch(add(get(props, 'prefix') ? `${get(props, 'prefix')}${path}` : path))
      await dispatch(get(combinedActions, path)(...args))
      await dispatch(remove(get(props, 'prefix') ? `${get(props, 'prefix')}${path}` : path))
  // eslint-disable-next-line
  }, [])
}
export default useAction